import type { FC, ReactNode } from "react";
import { fullWidthDiv } from "src/website-apps/responsive/stubhub-performer/components/page-body/body.styles";

// Passthrough wrapper used when the performer card is not shown in the body.
// Renders a full-width div, accepting (and ignoring) PortalColLeft-compatible
// props (setMinHeight, flex) so it is substitutable for PortalColLeft.
export const FullWidthDivWrapper: FC<{ children?: ReactNode }> = ({ children }) => (
  <div className={fullWidthDiv}>{children}</div>
);
